import { AppListenerMiddleware } from "@src/store/rootState";
import { getAiChatSessionId } from "@src/store/slices/aiChat";
import { ideasSlice } from "@src/store/slices/experienceBuilder/ideas/slice";
import { selectedExperience } from "@src/store/slices/experiences";
import { mpVivIdeaLibraryViewed } from "@src/utils/mixpanel";

const { _openLibrary } = ideasSlice.actions;

/**
 * Tracks the Idea Library slide-over being opened. Listens on the action rather
 * than the click so every entry point (the empty state's "Browse more ideas",
 * the toolbar menu) is covered by construction.
 *
 * `chatId` is populated even though the library is only reachable before the
 * first turn: `openBuilder` seeds the session id, so the event joins to the chat
 * an idea goes on to start.
 *
 * The idea-chosen event fires inside the `sendIdea` thunk instead — it has to
 * sit behind that thunk's preview-ready gate, which an action listener can't
 * see. See `thunks/sendIdea`.
 */
export function setupIdeasMixPanelListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: _openLibrary,
    effect: (_action, { getState }) => {
      mpVivIdeaLibraryViewed({
        experienceId: selectedExperience(getState())?.id,
        chatId: getAiChatSessionId(getState()),
      });
    },
  });
}
